import { render } from "./VoucherRegistrationsTab.vue?vue&type=template&id=5c587bb1&scoped=true"
import script from "./VoucherRegistrationsTab.vue?vue&type=script&lang=js"
export * from "./VoucherRegistrationsTab.vue?vue&type=script&lang=js"

import "./VoucherRegistrationsTab.vue?vue&type=style&index=0&id=5c587bb1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c587bb1"]])

export default __exports__